import {
    Link,
    Text
} from "@fluentui/react";
import { RootState } from "app/store";
import SimpleCard, { ECardIcon, ICardProperties } from "components/controls/SimpleCard";
import { AppLinkTo, appStyles } from "global/Application";
import { IFeesAndPremiumList } from "model/CRM.type";
import {
    IFeesAndPremiums as FAM_IFeesAndPremiums,
    IPlan as FAM_IPlan
} from "model/FlexibleAttributeModel";
import React from "react";
import { useHistory } from "react-router";

interface IProps extends ICardProperties {
    feesAndPremium?: FAM_IFeesAndPremiums;
    state: RootState;
    contextPlans?: FAM_IPlan[];
    icon?: ECardIcon;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    feesAndPremiumCollection?: IFeesAndPremiumList;
}

const FeesAndPremiumCard: React.FC<IProps> = (props) => {
    const history = useHistory();

    const callout = () => {

        const plans: FAM_IPlan[] = [];

        props.contextPlans?.forEach(eachPlan => {
            if (eachPlan.deactivated)
                return;

            if (eachPlan.feesAndPremiumsRef?.id === props.feesAndPremium?.id)
                plans.push(eachPlan);
        });

        return <>
            <Text block variant="xLarge" className={appStyles.title}>
                Fees And Premium
            </Text>

            <Text>
                {props.feesAndPremium?.name ?? props.description}
            </Text>

            {plans.length > 0 &&
                <>
                    <Text block variant="xLarge" className={appStyles.title}>
                        Plans ({plans.length})
                    </Text>
                    <ul className={appStyles.cardPadding}>
                        {plans.map(p =>
                            <li>
                                <Link onClick={() => history.push(AppLinkTo(props.state, { type: 'plan', id: p?.id! }))}>
                                    <Text variant="small">
                                        {p?.name}
                                    </Text>
                                </Link>
                            </li>
                        )}
                    </ul>
                </>
            }
        </>
    }

    const selected = props.feesAndPremiumCollection?.some(t => t.selected && props.feesAndPremium?.id === t.item.id);

    return (
        <SimpleCard
            {...props}
            key={props.feesAndPremium?.id ?? undefined}
            description={props.feesAndPremium?.name ?? props.description}
            selected={selected}
            onCallout={callout}
            header="FP"
            onClick={props.onClick}
        />
    )
}

export default FeesAndPremiumCard;